// ADR-142 §10 — display labels for the structured episode end reasons
// (radar-api src/utils/endReasons.js). Shared by the contract card and the
// ADR-168 closed-contract correction modal, so the two never label one value
// differently.
export const END_REASON_LABELS = {
  EXPIRED_RAN_TO_TERM: 'Expired (ran to term)',
  REPLACED_RENEWED: 'Replaced (renewed)',
  CANCELLED_BEFORE_TERM: 'Cancelled before term',
  RESIGNED: 'Resigned',
  TERMINATED: 'Terminated',
  NO_SHOW: 'No-show',
  HIRE_WITHDRAWN: 'Hire withdrawn',
  // ADR-159 — one contract voided before its start (Void Contract, or a
  // contract that would have begun after the person's resignation date)
  VOIDED_BEFORE_START: 'Voided before start',
  // ADR-171 C2 — closed because the person's primary contract closed
  PRIMARY_CLOSED: 'Closed with the primary contract',
};

export const END_REASON_OPTIONS = Object.entries(END_REASON_LABELS)
  .map(([value, label]) => ({ value, label }));
